module.exports = __webpack_public_path__ + "static/media/pizza-milano-2.db9f0995.jpg";